<!DOCTYPE html>
<!--
  Flaticon icon font: Flaticon
  Creation date: 25/09/2017 11:10
-->
<html>
<!DOCTYPE html>
<html>

<head>
    <title>Flaticon WebFont</title>
    <link href="http://fonts.googleapis.com/css?family=Varela+Round" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" type="text/css" href="flaticon_medical.css">
    <meta charset="UTF-8">
    <style>
    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed, 
    figure, figcaption, footer, header, hgroup, 
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
    }
    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure, 
    footer, header, hgroup, menu, nav, section {
        display: block;
    }
    body {
        line-height: 1;
    }
    ol, ul {
        list-style: none;
    }
    blockquote, q {
        quotes: none;
    }
    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
    body {
        font-family: 'Varela Round', Helvetica, Arial, sans-serif;
        font-size: 16px;
        color: #222;
    }
    a {
        color: #333;
        border-bottom: 1px solid #a9fd00;
        font-weight: bold;
        text-decoration: none;
    }
    * {
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }
    [class^="flaticon-"]:before, [class*=" flaticon-"]:before, [class^="flaticon-"]:after, [class*=" flaticon-"]:after {
        font-family: Flaticon;
        font-size: 30px;
        font-style: normal;
        margin-left: 20px;
        color: #333;
    }
    .wrapper {
        max-width: 600px;
        margin: auto;
        padding: 0 1em;
    }
    .title {
        font-size: 1.25em;
        text-align: center;
        margin-bottom: 1em;
        text-transform: uppercase;
    }
    header {
        text-align: center;
        background-color: #222;
        color: #fff;
        padding: 1em;
    }
    header .logo {
        width: 210px;
        height: 38px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 1em;
        border: none;
    }
    header strong {
        font-size: 1.95em;
        font-weight: bold;
        vertical-align: middle;
        margin-top: 5px;
        display: inline-block;
    }
    .demo {
        margin: 2em auto;
        line-height: 1.25em;
    }
    .demo ul li {
        margin-bottom: 1em;
    }
    .demo ul li .num {
        color: #222;
        border-radius: 20px;
        display: inline-block;
        width: 26px;
        padding: 3px;
        height: 26px;
        text-align: center;
        margin-right: 0.5em;
        border: 1px solid #222;
    }
    .demo ul li code {
        background-color: #222;
        border-radius: 4px;
        padding: 0.25em 0.5em;
        display: inline-block;
        color: #fff;
        font-family: Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New, monospace;
        font-weight: lighter;
        margin-top: 1em;
        font-size: 0.8em;
        word-break: break-all;
    }
    .demo ul li code.big {
        padding: 1em;
        font-size: 0.9em;
    }
    .demo ul li code .red {
        color: #EF3159;
    }
    .demo ul li code .green {
        color: #ACFF65;
    }
    .demo ul li code .yellow {
        color: #FFFF99;
    }
    .demo ul li code .blue {
        color: #99D3FF;
    }
    .demo ul li code .purple {
        color: #A295FF;
    }
    .demo ul li code .dots {
        margin-top: 0.5em;
        display: block;
    }
    #glyphs {
        border-bottom: 1px solid #ccc;
        padding: 2em 0;
        text-align: center;
    }
    .glyph {
        display: inline-block;
        width: 9em;
        margin: 1em;
        text-align: center;
        vertical-align: top;
        background: #FFF;
    }
    .glyph .glyph-icon {
        padding: 10px;
        display: block;
        font-family:"Flaticon";
        font-size: 64px;
        line-height: 1;
    }
    .glyph .glyph-icon:before {
        font-size: 64px;
        color: #222;
        margin-left: 0;
    }
    .class-name {
        font-size: 0.65em;
        background-color: #222;
        color: #fff;
        border-radius: 4px 4px 0 0;
        padding: 0.5em;
        color: #FFFF99;
        font-family: Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New, monospace;
    }
    .author-name {
        font-size: 0.6em;
        background-color: #fcfcfd;
        border: 1px solid #DEDEE4;
        border-top: 0;
        border-radius: 0 0 4px 4px;
        padding: 0.5em;
    }
    .class-name:last-child {
        font-size: 10px;
        color:#888;
    }
    .class-name:last-child a {
        font-size: 10px;
        color:#555;
    }
    .class-name:last-child a:hover {
        color:#a9fd00;
    }
    .glyph > input {
        display: block;
        width: 100px;
        margin: 5px auto;
        text-align: center;
        font-size: 12px;
        cursor: text;
    }
    .glyph > input.icon-input {
        font-family:"Flaticon";
        font-size: 16px;
        margin-bottom: 10px;
    }
    .attribution .title {
        margin-top: 2em;
    }
    .attribution textarea {
        background-color: #fcfcfd;
        padding: 1em;
        border: none;
        box-shadow: none;
        border: 1px solid #DEDEE4;
        border-radius: 4px;
        resize: none;
        width: 100%;
        height: 150px;
        font-size: 0.8em;
        font-family: Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New, monospace;
        -webkit-appearance: none;
    }
    .iconsuse {
        margin: 2em auto;
        text-align: center;
        max-width: 1200px;
    }
    .iconsuse:after {
        content: '';
        display: table;
        clear: both;
    }
    .iconsuse .image {
        float: left;
        width: 25%;
        padding: 0 1em;
    }
    .iconsuse .image p {
        margin-bottom: 1em;
    }
    .iconsuse .image span {
        display: block;
        font-size: 0.65em;
        background-color: #222;
        color: #fff;
        border-radius: 4px;
        padding: 0.5em;
        color: #FFFF99;
        margin-top: 1em;
        font-family: Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New, monospace;
    }
    #footer {
        text-align: center;
        background-color: #4C5B5C;
        color: #7c9192;
        padding: 1em;
    }
    #footer a {
        border: none;
        color: #a9fd00;
        font-weight: normal;
    }
    @media (max-width: 960px) {
        .iconsuse .image {
            width: 50%;
        }
    }
    @media (max-width: 560px) {
        .iconsuse .image {
            width: 100%;
        }
    }
    </style>
</head>

<body class="characters-off">

    <header>
        <a href="http://www.flaticon.com" target="_blank" class="logo">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/" viewBox="0 0 560.875 102.036" enable-background="new 0 0 560.875 102.036" xml:space="preserve">
                <defs>
                </defs>
                <g>
                    <g class="letters">
                        <path fill="#ffffff" d="M141.596,29.675c0-3.777,2.985-6.767,6.764-6.767h34.438c3.426,0,6.15,2.728,6.15,6.15
                        c0,3.43-2.724,6.149-6.15,6.149h-27.674v13.091h23.719c3.429,0,6.151,2.724,6.151,6.15c0,3.43-2.723,6.149-6.151,6.149h-23.719
                        v17.574c0,3.773-2.986,6.761-6.764,6.761c-3.779,0-6.764-2.989-6.764-6.761V29.675z"></path>
                        <path fill="#ffffff" d="M193.844,29.149c0-3.781,2.985-6.767,6.764-6.767c3.776,0,6.763,2.985,6.763,6.767v42.957h25.039
                        c3.426,0,6.149,2.726,6.149,6.153c0,3.425-2.723,6.15-6.149,6.15h-31.802c-3.779,0-6.764-2.986-6.764-6.768V29.149z"></path>
                        <path fill="#ffffff" d="M241.891,75.71l21.438-48.407c1.492-3.341,4.215-5.357,7.906-5.357h0.792
                        c3.686,0,6.323,2.017,7.815,5.357l21.439,48.407c0.436,0.967,0.701,1.845,0.701,2.723c0,3.602-2.809,6.501-6.414,6.501
                        c-3.161,0-5.269-1.845-6.499-4.655l-4.132-9.661h-27.059l-4.301,10.102c-1.144,2.631-3.426,4.214-6.237,4.214
                        c-3.517,0-6.24-2.81-6.24-6.325C241.1,77.64,241.451,76.677,241.891,75.71z M279.932,58.666l-8.521-20.297l-8.526,20.297H279.932
                        z"></path>
                        <path fill="#ffffff" d="M314.864,35.387H301.86c-3.429,0-6.239-2.813-6.239-6.238c0-3.429,2.811-6.24,6.239-6.24h39.533
                        c3.426,0,6.237,2.811,6.237,6.24c0,3.425-2.811,6.238-6.237,6.238h-13.001v42.785c0,3.773-2.99,6.761-6.764,6.761
                        c-3.779,0-6.764-2.989-6.764-6.761V35.387z"></path>
                        <path fill="#A9FD00" d="M352.615,29.149c0-3.781,2.985-6.767,6.767-6.767c3.774,0,6.761,2.985,6.761,6.767v49.024
                        c0,3.773-2.987,6.761-6.761,6.761c-3.781,0-6.767-2.989-6.767-6.761V29.149z"></path>
                        <path fill="#A9FD00" d="M374.132,53.836v-0.179c0-17.481,13.178-31.801,32.065-31.801c9.22,0,15.459,2.458,20.557,6.238
                        c1.402,1.054,2.637,2.985,2.637,5.357c0,3.692-2.985,6.59-6.681,6.59c-1.845,0-3.071-0.702-4.044-1.319
                        c-3.776-2.813-7.729-4.393-12.562-4.393c-10.364,0-17.831,8.611-17.831,19.154v0.173c0,10.542,7.291,19.329,17.831,19.329
                        c5.715,0,9.492-1.756,13.359-4.834c1.049-0.874,2.458-1.491,4.039-1.491c3.429,0,6.325,2.813,6.325,6.236
                        c0,2.106-1.056,3.78-2.282,4.834c-5.539,4.834-12.036,7.733-21.878,7.733C387.572,85.464,374.132,71.493,374.132,53.836z"></path>
                        <path fill="#A9FD00" d="M433.009,53.836v-0.179c0-17.481,13.79-31.801,32.766-31.801c18.981,0,32.592,14.143,32.592,31.628v0.173
                        c0,17.483-13.785,31.807-32.769,31.807C446.625,85.464,433.009,71.32,433.009,53.836z M484.224,53.836v-0.179
                        c0-10.539-7.725-19.326-18.626-19.326c-10.893,0-18.449,8.611-18.449,19.154v0.173c0,10.542,7.73,19.329,18.626,19.329
                        C476.676,72.986,484.224,64.378,484.224,53.836z"></path>
                        <path fill="#A9FD00" d="M506.233,29.321c0-3.774,2.99-6.763,6.767-6.763h1.401c3.252,0,5.183,1.583,7.029,3.953l26.093,34.265
                        V29.059c0-3.692,2.99-6.677,6.681-6.677c3.683,0,6.671,2.985,6.671,6.677v48.934c0,3.78-2.987,6.765-6.764,6.765h-0.436
                        c-3.257,0-5.188-1.581-7.034-3.953l-27.056-35.492v32.944c0,3.687-2.985,6.676-6.678,6.676c-3.683,0-6.673-2.989-6.673-6.676
                        V29.321z"></path>
                    </g>
                    <g class="insignia">
                        <path fill="#ffffff" d="M48.372,56.137h12.517l11.156-18.537H37.186L25.688,18.539h57.825L94.668,0H9.271
                        C5.925,0,2.842,1.801,1.198,4.716c-1.644,2.907-1.593,6.482,0.134,9.343l50.38,83.501c1.678,2.781,4.689,4.476,7.938,4.476
                        c3.246,0,6.257-1.695,7.935-4.476l2.898-4.804L48.372,56.137z"></path>
                        <g class="i">
                            <path fill="#A9FD00" d="M93.575,18.539h0.031v0.004l21.652,0.004l2.705-4.488c1.727-2.861,1.778-6.436,0.133-9.343
                            C116.454,1.801,113.371,0,110.026,0h-5.294L93.575,18.539z"></path>
                            <polygon fill="#A9FD00" points="88.291,27.356 64.725,66.486 75.519,84.404 109.942,27.356"></polygon>
                        </g>
                    </g>
                </g>
            </svg>
        </a>
        <strong>Font Demo</strong>
    </header>


    <section class="demo wrapper">

        <p class="title">Instructions</p>

        <ul>
            <li>
                <span class="num">1</span>Copy the "Fonts" files and CSS files to your website CSS folder.
            </li>
            <li>
                <span class="num">2</span>Add the CSS link to your website source code on header.
                <code class="big">
                    &lt;<span class="red">head</span>&gt;
                    <br/><span class="dots">...</span>
                    <br/>&lt;<span class="red">link</span> <span class="green">rel</span>=<span class="yellow">"stylesheet"</span> <span class="green">type</span>=<span class="yellow">"text/css"</span> <span class="green">href</span>=<span class="yellow">"your_website_domain/css_root/flaticon.css"</span>&gt;
                    <br/><span class="dots">...</span>
                    <br/>&lt;/<span class="red">head</span>&gt;
                </code>
            </li>

            <li>
                <p>
                    <span class="num">3</span>Use the icon class on <code>"<span class="blue">display</span>:<span class="purple"> inline</span>"</code> elements:
                    <br />
                    Use example: <code>&lt;<span class="red">i</span> <span class="green">class</span>=<span class="yellow">&quot;flaticon-airplane49&quot;</span>&gt;&lt;/<span class="red">i</span>&gt;</code> or <code>&lt;<span class="red">span</span> <span class="green">class</span>=<span class="yellow">&quot;flaticon-airplane49&quot;</span>&gt;&lt;/<span class="red">span</span>&gt;</code>
            </li>
        </ul>

    </section>




   <section id="glyphs">          
    
      
        <div class="glyph"><div class="glyph-icon flaticon-technology"></div>
            <div class="class-name">.flaticon-technology</div>
            <div class="author-name">Author: <a data-file="001-technology" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-42"></div>
            <div class="class-name">.flaticon-medical-42</div>
            <div class="author-name">Author: <a data-file="002-medical-42" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-41"></div>
            <div class="class-name">.flaticon-medical-41</div>
            <div class="author-name">Author: <a data-file="003-medical-41" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-people-10"></div>
            <div class="class-name">.flaticon-people-10</div>
            <div class="author-name">Author: <a data-file="004-people-10" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-people-9"></div>
            <div class="class-name">.flaticon-people-9</div>
            <div class="author-name">Author: <a data-file="005-people-9" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-16"></div>
            <div class="class-name">.flaticon-medical-16</div>
            <div class="author-name">Author: <a data-file="006-medical-16" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-clinic-history"></div>
            <div class="class-name">.flaticon-clinic-history</div>
            <div class="author-name">Author: <a data-file="007-clinic-history" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-cardiogram"></div>
            <div class="class-name">.flaticon-cardiogram</div>
            <div class="author-name">Author: <a data-file="008-cardiogram" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-people-8"></div>
            <div class="class-name">.flaticon-people-8</div>
            <div class="author-name">Author: <a data-file="009-people-8" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-people-7"></div>
            <div class="class-name">.flaticon-people-7</div>
            <div class="author-name">Author: <a data-file="010-people-7" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-tool-3"></div>
            <div class="class-name">.flaticon-tool-3</div>
            <div class="author-name">Author: <a data-file="011-tool-3" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-tool-2"></div>
            <div class="class-name">.flaticon-tool-2</div>
            <div class="author-name">Author: <a data-file="012-tool-2" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-people-6"></div>
            <div class="class-name">.flaticon-people-6</div>
            <div class="author-name">Author: <a data-file="013-people-6" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-40"></div>
            <div class="class-name">.flaticon-medical-40</div>
            <div class="author-name">Author: <a data-file="014-medical-40" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-people-5"></div>
            <div class="class-name">.flaticon-people-5</div>
            <div class="author-name">Author: <a data-file="015-people-5" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-39"></div>
            <div class="class-name">.flaticon-medical-39</div>
            <div class="author-name">Author: <a data-file="016-medical-39" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-tool-1"></div>
            <div class="class-name">.flaticon-tool-1</div>
            <div class="author-name">Author: <a data-file="017-tool-1" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-38"></div>
            <div class="class-name">.flaticon-medical-38</div>
            <div class="author-name">Author: <a data-file="018-medical-38" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-monitor"></div>
            <div class="class-name">.flaticon-monitor</div>
            <div class="author-name">Author: <a data-file="019-monitor" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-37"></div>
            <div class="class-name">.flaticon-medical-37</div>
            <div class="author-name">Author: <a data-file="020-medical-37" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-36"></div>
            <div class="class-name">.flaticon-medical-36</div>
            <div class="author-name">Author: <a data-file="021-medical-36" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-35"></div>
            <div class="class-name">.flaticon-medical-35</div>
            <div class="author-name">Author: <a data-file="022-medical-35" href="https://www.flaticon.com/authors/swifticons">Swifticons</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-34"></div>
            <div class="class-name">.flaticon-medical-34</div>
            <div class="author-name">Author: <a data-file="023-medical-34" href="https://www.flaticon.com/authors/zlatko-najdenovski">Zlatko Najdenovski</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-33"></div>
            <div class="class-name">.flaticon-medical-33</div>
            <div class="author-name">Author: <a data-file="024-medical-33" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-vision"></div>
            <div class="class-name">.flaticon-vision</div>
            <div class="author-name">Author: <a data-file="025-vision" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-32"></div>
            <div class="class-name">.flaticon-medical-32</div>
            <div class="author-name">Author: <a data-file="026-medical-32" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-14"></div>
            <div class="class-name">.flaticon-medical-14</div>
            <div class="author-name">Author: <a data-file="027-medical-14" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-31"></div>
            <div class="class-name">.flaticon-medical-31</div>
            <div class="author-name">Author: <a data-file="028-medical-31" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-people-4"></div>
            <div class="class-name">.flaticon-people-4</div>
            <div class="author-name">Author: <a data-file="029-people-4" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-computer"></div>
            <div class="class-name">.flaticon-computer</div>
            <div class="author-name">Author: <a data-file="030-computer" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-healthy-4"></div>
            <div class="class-name">.flaticon-healthy-4</div>
            <div class="author-name">Author: <a data-file="031-healthy-4" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-30"></div>
            <div class="class-name">.flaticon-medical-30</div>
            <div class="author-name">Author: <a data-file="032-medical-30" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-29"></div>
            <div class="class-name">.flaticon-medical-29</div>
            <div class="author-name">Author: <a data-file="033-medical-29" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-28"></div>
            <div class="class-name">.flaticon-medical-28</div>
            <div class="author-name">Author: <a data-file="034-medical-28" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-folder"></div>
            <div class="class-name">.flaticon-folder</div>
            <div class="author-name">Author: <a data-file="035-folder" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-27"></div>
            <div class="class-name">.flaticon-medical-27</div>
            <div class="author-name">Author: <a data-file="036-medical-27" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-26"></div>
            <div class="class-name">.flaticon-medical-26</div>
            <div class="author-name">Author: <a data-file="037-medical-26" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medicine"></div>
            <div class="class-name">.flaticon-medicine</div>
            <div class="author-name">Author: <a data-file="038-medicine" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-25"></div>
            <div class="class-name">.flaticon-medical-25</div>
            <div class="author-name">Author: <a data-file="039-medical-25" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-24"></div>
            <div class="class-name">.flaticon-medical-24</div>
            <div class="author-name">Author: <a data-file="040-medical-24" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-23"></div>
            <div class="class-name">.flaticon-medical-23</div>
            <div class="author-name">Author: <a data-file="041-medical-23" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-sign-1"></div>
            <div class="class-name">.flaticon-sign-1</div>
            <div class="author-name">Author: <a data-file="042-sign-1" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-22"></div>
            <div class="class-name">.flaticon-medical-22</div>
            <div class="author-name">Author: <a data-file="043-medical-22" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-21"></div>
            <div class="class-name">.flaticon-medical-21</div>
            <div class="author-name">Author: <a data-file="044-medical-21" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-danger"></div>
            <div class="class-name">.flaticon-danger</div>
            <div class="author-name">Author: <a data-file="045-danger" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-20"></div>
            <div class="class-name">.flaticon-medical-20</div>
            <div class="author-name">Author: <a data-file="046-medical-20" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-19"></div>
            <div class="class-name">.flaticon-medical-19</div>
            <div class="author-name">Author: <a data-file="047-medical-19" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-18"></div>
            <div class="class-name">.flaticon-medical-18</div>
            <div class="author-name">Author: <a data-file="048-medical-18" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-healthy-3"></div>
            <div class="class-name">.flaticon-healthy-3</div>
            <div class="author-name">Author: <a data-file="049-healthy-3" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-17"></div>
            <div class="class-name">.flaticon-medical-17</div>
            <div class="author-name">Author: <a data-file="050-medical-17" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-care"></div>
            <div class="class-name">.flaticon-care</div>
            <div class="author-name">Author: <a data-file="051-care" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-people-3"></div>
            <div class="class-name">.flaticon-people-3</div>
            <div class="author-name">Author: <a data-file="052-people-3" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-people-2"></div>
            <div class="class-name">.flaticon-people-2</div>
            <div class="author-name">Author: <a data-file="053-people-2" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-15"></div>
            <div class="class-name">.flaticon-medical-15</div>
            <div class="author-name">Author: <a data-file="054-medical-15" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-tool"></div>
            <div class="class-name">.flaticon-tool</div>
            <div class="author-name">Author: <a data-file="055-tool" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-people-1"></div>
            <div class="class-name">.flaticon-people-1</div>
            <div class="author-name">Author: <a data-file="056-people-1" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-microscope-2"></div>
            <div class="class-name">.flaticon-microscope-2</div>
            <div class="author-name">Author: <a data-file="057-microscope-2" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-microscope-1"></div>
            <div class="class-name">.flaticon-microscope-1</div>
            <div class="author-name">Author: <a data-file="058-microscope-1" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-microscope"></div>
            <div class="class-name">.flaticon-microscope</div>
            <div class="author-name">Author: <a data-file="059-microscope" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-stethoscope"></div>
            <div class="class-name">.flaticon-stethoscope</div>
            <div class="author-name">Author: <a data-file="060-stethoscope" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-surgeon"></div>
            <div class="class-name">.flaticon-surgeon</div>
            <div class="author-name">Author: <a data-file="061-surgeon" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-healthy-2"></div>
            <div class="class-name">.flaticon-healthy-2</div>
            <div class="author-name">Author: <a data-file="062-healthy-2" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-healthy-1"></div>
            <div class="class-name">.flaticon-healthy-1</div>
            <div class="author-name">Author: <a data-file="063-healthy-1" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-healthy"></div>
            <div class="class-name">.flaticon-healthy</div>
            <div class="author-name">Author: <a data-file="064-healthy" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-13"></div>
            <div class="class-name">.flaticon-medical-13</div>
            <div class="author-name">Author: <a data-file="065-medical-13" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-pills"></div>
            <div class="class-name">.flaticon-pills</div>
            <div class="author-name">Author: <a data-file="066-pills" href="https://www.flaticon.com/authors/sean-mccormick">Sean McCormick</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-people"></div>
            <div class="class-name">.flaticon-people</div>
            <div class="author-name">Author: <a data-file="067-people" href="https://www.flaticon.com/authors/vectors-market">Vectors Market</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-smoking-area"></div>
            <div class="class-name">.flaticon-smoking-area</div>
            <div class="author-name">Author: <a data-file="068-smoking-area" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-electrocardiogram-on-heart-shape"></div>
            <div class="class-name">.flaticon-electrocardiogram-on-heart-shape</div>
            <div class="author-name">Author: <a data-file="069-electrocardiogram-on-heart-shape" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-man"></div>
            <div class="class-name">.flaticon-man</div>
            <div class="author-name">Author: <a data-file="070-man" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-12"></div>
            <div class="class-name">.flaticon-medical-12</div>
            <div class="author-name">Author: <a data-file="071-medical-12" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-sign"></div>
            <div class="class-name">.flaticon-sign</div>
            <div class="author-name">Author: <a data-file="072-sign" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-heart-rate-monitor-1"></div>
            <div class="class-name">.flaticon-heart-rate-monitor-1</div>
            <div class="author-name">Author: <a data-file="073-heart-rate-monitor-1" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-lifeline-of-heartbeats-on-a-paper-on-a-clipboard"></div>
            <div class="class-name">.flaticon-lifeline-of-heartbeats-on-a-paper-on-a-clipboard</div>
            <div class="author-name">Author: <a data-file="074-lifeline-of-heartbeats-on-a-paper-on-a-clipboard" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-tool-to-listen-heart-beats"></div>
            <div class="class-name">.flaticon-medical-tool-to-listen-heart-beats</div>
            <div class="author-name">Author: <a data-file="075-medical-tool-to-listen-heart-beats" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-heart-beat"></div>
            <div class="class-name">.flaticon-heart-beat</div>
            <div class="author-name">Author: <a data-file="076-heart-beat" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-heartbeats-monitoring"></div>
            <div class="class-name">.flaticon-heartbeats-monitoring</div>
            <div class="author-name">Author: <a data-file="077-heartbeats-monitoring" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-11"></div>
            <div class="class-name">.flaticon-medical-11</div>
            <div class="author-name">Author: <a data-file="078-medical-11" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-10"></div>
            <div class="class-name">.flaticon-medical-10</div>
            <div class="author-name">Author: <a data-file="079-medical-10" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-9"></div>
            <div class="class-name">.flaticon-medical-9</div>
            <div class="author-name">Author: <a data-file="080-medical-9" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-heartbeat"></div>
            <div class="class-name">.flaticon-heartbeat</div>
            <div class="author-name">Author: <a data-file="081-heartbeat" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-heart-rate-monitor"></div>
            <div class="class-name">.flaticon-heart-rate-monitor</div>
            <div class="author-name">Author: <a data-file="082-heart-rate-monitor" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-unhealthy"></div>
            <div class="class-name">.flaticon-unhealthy</div>
            <div class="author-name">Author: <a data-file="083-unhealthy" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-cigarette-with-smoke"></div>
            <div class="class-name">.flaticon-cigarette-with-smoke</div>
            <div class="author-name">Author: <a data-file="084-cigarette-with-smoke" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-8"></div>
            <div class="class-name">.flaticon-medical-8</div>
            <div class="author-name">Author: <a data-file="085-medical-8" href="https://www.flaticon.com/authors/vectors-market">Vectors Market</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-smoking-1"></div>
            <div class="class-name">.flaticon-smoking-1</div>
            <div class="author-name">Author: <a data-file="086-smoking-1" href="https://www.flaticon.com/authors/roundicons-freebies">Roundicons Freebies</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-smoking"></div>
            <div class="class-name">.flaticon-smoking</div>
            <div class="author-name">Author: <a data-file="087-smoking" href="https://www.flaticon.com/authors/dot-on-paper">Dot on Paper</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-shapes"></div>
            <div class="class-name">.flaticon-shapes</div>
            <div class="author-name">Author: <a data-file="088-shapes" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-7"></div>
            <div class="class-name">.flaticon-medical-7</div>
            <div class="author-name">Author: <a data-file="089-medical-7" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-6"></div>
            <div class="class-name">.flaticon-medical-6</div>
            <div class="author-name">Author: <a data-file="090-medical-6" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-5"></div>
            <div class="class-name">.flaticon-medical-5</div>
            <div class="author-name">Author: <a data-file="091-medical-5" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-4"></div>
            <div class="class-name">.flaticon-medical-4</div>
            <div class="author-name">Author: <a data-file="092-medical-4" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-3"></div>
            <div class="class-name">.flaticon-medical-3</div>
            <div class="author-name">Author: <a data-file="093-medical-3" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-2"></div>
            <div class="class-name">.flaticon-medical-2</div>
            <div class="author-name">Author: <a data-file="094-medical-2" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical-1"></div>
            <div class="class-name">.flaticon-medical-1</div>
            <div class="author-name">Author: <a data-file="095-medical-1" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-heart-beating"></div>
            <div class="class-name">.flaticon-heart-beating</div>
            <div class="author-name">Author: <a data-file="096-heart-beating" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-medical"></div>
            <div class="class-name">.flaticon-medical</div>
            <div class="author-name">Author: <a data-file="097-medical" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-human"></div>
            <div class="class-name">.flaticon-human</div>
            <div class="author-name">Author: <a data-file="098-human" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        
        <div class="glyph"><div class="glyph-icon flaticon-cigarette"></div>
            <div class="class-name">.flaticon-cigarette</div>
            <div class="author-name">Author: <a data-file="099-cigarette" href="http://www.freepik.com">Freepik</a> </div> 
        </div>        
        

    </section>



    <section class="attribution wrapper"   style="text-align:center;">

      <div class="title">License and attribution:</div><div class="attrDiv">Font generated by <a href="http://www.flaticon.com">flaticon.com</a>. <div><p>Under <a href="http://creativecommons.org/licenses/by/3.0/">CC</a>: <a data-file="002-medical-42" href="http://www.freepik.com">Freepik</a>, <a data-file="087-smoking" href="https://www.flaticon.com/authors/dot-on-paper">Dot on Paper</a>, <a data-file="086-smoking-1" href="https://www.flaticon.com/authors/roundicons-freebies">Roundicons Freebies</a>, <a data-file="067-people" href="https://www.flaticon.com/authors/vectors-market">Vectors Market</a>, <a data-file="066-pills" href="https://www.flaticon.com/authors/sean-mccormick">Sean McCormick</a>, <a data-file="025-vision" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a>, <a data-file="003-medical-41" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a>, <a data-file="001-technology" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a>, <a data-file="020-medical-37" href="https://www.flaticon.com/authors/smashicons">Smashicons</a>, <a data-file="023-medical-34" href="https://www.flaticon.com/authors/zlatko-najdenovski">Zlatko Najdenovski</a>, <a data-file="022-medical-35" href="https://www.flaticon.com/authors/swifticons">Swifticons</a></p>  </div>
      </div>
      <div class="title">Copy the Attribution License:</div>

    <textarea onclick="this.focus();this.select();">Font generated by &lt;a href=&quot;http://www.flaticon.com&quot;&gt;flaticon.com&lt;/a&gt;. <p>Under <a href="http://creativecommons.org/licenses/by/3.0/">CC</a>: <a data-file="002-medical-42" href="http://www.freepik.com">Freepik</a>, <a data-file="087-smoking" href="https://www.flaticon.com/authors/dot-on-paper">Dot on Paper</a>, <a data-file="086-smoking-1" href="https://www.flaticon.com/authors/roundicons-freebies">Roundicons Freebies</a>, <a data-file="067-people" href="https://www.flaticon.com/authors/vectors-market">Vectors Market</a>, <a data-file="066-pills" href="https://www.flaticon.com/authors/sean-mccormick">Sean McCormick</a>, <a data-file="025-vision" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a>, <a data-file="003-medical-41" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a>, <a data-file="001-technology" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a>, <a data-file="020-medical-37" href="https://www.flaticon.com/authors/smashicons">Smashicons</a>, <a data-file="023-medical-34" href="https://www.flaticon.com/authors/zlatko-najdenovski">Zlatko Najdenovski</a>, <a data-file="022-medical-35" href="https://www.flaticon.com/authors/swifticons">Swifticons</a></p>  
     </textarea>

    </section>

    <section class="iconsuse">

          <div class="title">Examples:</div>            
             
            <div class="image">
                <p>
                    <i class="glyph-icon flaticon-technology"></i> 
                    <span>&lt;i class=&quot;flaticon-technology&quot;&gt;&lt;/i&gt;</span>
                </p>
            </div>
            
            <div class="image">
                <p>
                    <i class="glyph-icon flaticon-medical-42"></i> 
                    <span>&lt;i class=&quot;flaticon-medical-42&quot;&gt;&lt;/i&gt;</span>
                </p>
            </div>
            
            <div class="image">
                <p>
                    <i class="glyph-icon flaticon-medical-41"></i> 
                    <span>&lt;i class=&quot;flaticon-medical-41&quot;&gt;&lt;/i&gt;</span>
                </p>
            </div>
            
            <div class="image">
                <p>
                    <i class="glyph-icon flaticon-people-10"></i> 
                    <span>&lt;i class=&quot;flaticon-people-10&quot;&gt;&lt;/i&gt;</span>
                </p>
            </div>
                       
        </div>
                            
    </section>

<div id="footer">
    <div>Generated by <a href="http://www.flaticon.com">flaticon.com</a>
    </div>
</div>



</body>
</html>
